import { render, staticRenderFns } from "./ProspectIdentifier.vue?vue&type=template&id=b0b970ba&scoped=true"
import script from "./ProspectIdentifier.vue?vue&type=script&lang=ts"
export * from "./ProspectIdentifier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b970ba",
  null
  
)

export default component.exports